import { useEffect } from "react";
import { api } from "@/lib/api";
import Navbar from "@/components/landing/Navbar";
import ConfusionSection from "@/components/landing/ConfusionSection";
import Hero from "@/components/landing/Hero";
import SampleReportTeaser from "@/components/landing/SampleReportTeaser";
import FeatureHighlights from "@/components/landing/FeatureHighlights";
import StatsStrip from "@/components/landing/StatsStrip";
import WhyAssessmentMatters from "@/components/landing/WhyAssessmentMatters";
import DimensionsExplained from "@/components/landing/DimensionsExplained";
import { MultiDimensionalAptitude } from "@/components/landing/MultiDimensionalAptitude";
import ScienceSection from "@/components/landing/ScienceSection";
import FactorsAffectingAccuracy from "@/components/landing/FactorsAffectingAccuracy";
import CareerUniverse from "@/components/landing/CareerUniverse";
import PartnerSection from "@/components/landing/PartnerSection";
import HowItWorks from "@/components/landing/HowItWorks";
import TrustSection from "@/components/landing/TrustSection";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 150);
    }
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (!ref) return;
    api
      .post("/referral/track", {
        referral_code: ref,
        utm_source: params.get("utm_source"),
        utm_medium: params.get("utm_medium"),
        utm_campaign: params.get("utm_campaign"),
        utm_content: params.get("utm_content"),
        landing_page: window.location.pathname,
      })
      .then((res) => {
        if (res.data.valid) {
          localStorage.setItem(
            "csr_attribution",
            JSON.stringify({
              referral_code: ref,
              click_id: res.data.click_id,
              utm_source: params.get("utm_source"),
              utm_medium: params.get("utm_medium"),
              utm_campaign: params.get("utm_campaign"),
              utm_content: params.get("utm_content"),
              first_touch_at: res.data.first_touch_at,
            })
          );
        }
      })
      .catch(() => {});
  }, []);

  return (
    <div data-testid="landing-page">
      <Navbar />
      <ConfusionSection />
      <Hero />
      <SampleReportTeaser />
      <FeatureHighlights />
      <StatsStrip />
      <WhyAssessmentMatters />
      <DimensionsExplained />
      <MultiDimensionalAptitude />
      <ScienceSection />
      <FactorsAffectingAccuracy />
      <CareerUniverse />
      <PartnerSection />
      <HowItWorks />
      <TrustSection />
      <Footer />
    </div>
  );
}
